<script>
import ToggleSlots from './ToggleSlots'

export default {
  mixins: [ToggleSlots],
  props: {
    useDefaults: {
      type: Boolean,
      default: true,
    },
  },
  render(h) {
    return h(
      `button`,
      {
        class: [
          ` cursor-default relative align-middle pl-1 py-0 my-0 `,
          {
            ' button-reset inline-flex ': true,
            ' opacity-80 hover:opacity-100 ': this.useDefaults,
          },
        ],
        on: {
          click: this.slotUpdated,
        },
      },
      this.slotNodes[this.value]
    )
  },
}
</script>

<style lang="postcss" scoped>
button {
  &:hover {
    filter: drop-shadow(0 0 3px var(--accent-color));
  }
}
</style>
